import { render } from "./order-vehicle-table.vue?vue&type=template&id=091897b8&scoped=true&ts=true"
import script from "./order-vehicle-table.vue?vue&type=script&lang=ts"
export * from "./order-vehicle-table.vue?vue&type=script&lang=ts"

import "./order-vehicle-table.vue?vue&type=style&index=0&id=091897b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091897b8"]])

export default __exports__